/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TWebShareFolderRequest, TWebShareFolderModel, IMappers, TWebShareFolderResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IShareFolderResponseSchema } from '../../../entities/shared_folder/ShareFolderResponseSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createWebShareFolderModel(parameters: TWebShareFolderRequest): TWebShareFolderModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'shared-folders',
    pathApi: '/v1/web/share-folder/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebShareFolderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebShareFolderRequest;
}

export async function fetchWebShareFolder<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebShareFolderOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebShareFolderResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebShareFolderModel(parameters),
    config,
  )) as FetchResponse<TWebShareFolderResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IShareFolderResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebShareFolderResponse>;
}
